import {clearAll, serverSelectedIdsSelector} from 'features/server/model/serverSlice';
import {useMonitorSelection, IUseMonitorSelection} from 'entities/monitor';

export const useServerSelection = (): IUseMonitorSelection =>
    useMonitorSelection(serverSelectedIdsSelector, clearAll);

export default useServerSelection;
